import { Link } from 'gatsby';
import React, { ReactNode } from 'react';

interface AnyLinkProps {
	url?: string;
	children?: ReactNode;
	key?: number;
}

export const AnyLink = ({ url, children, key }: AnyLinkProps): JSX.Element => {
	if (!url) return <div key={key}>{children}</div>;
	const isExternalLink = new RegExp('^([a-z]+://|//)', 'i');
	return isExternalLink.test(url) ? (
		<a target="_blank" href={url} rel="noopener noreferrer" key={key}>
			{children}
		</a>
	) : (
		<Link to={url.startsWith('/') ? url : `/${url}`} key={key}>
			{children}
		</Link>
	);
};
